import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Modal } from 'components';
import { HtmlParserType } from 'scenes/common/helpers/html';

const ModalBodyContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  p {
    margin: 0;
  }
`;

const MarketingCampaignModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  disclaimerText: HtmlParserType;
  header: HtmlParserType;
}> = ({ isOpen, onClose, headerText, disclaimerText, header }) => (
  <Modal
    headerElement={header}
    header={headerText}
    isOpen={isOpen}
    onClose={onClose}
  >
    <ModalBodyContainer>{disclaimerText ?? ''}</ModalBodyContainer>
  </Modal>
);

export default MarketingCampaignModal;
